<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <component :growerId="growerId" :is="component"></component>
    </div>
</template>

<script>
import currentUserQuery from '@views/Growers/Container/queryCurrentUser.graphql';
import ContractorBrowse from './ContractorBrowse';

import ProcessorBrowse from './ProcessorBrowse';

export default {
  name: 'GrowerBlocksContainer',
  props: ['growerId'],
  components: {
    ProcessorBrowse,
    ContractorBrowse,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['processor', 'contractor', 'developer'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  computed: {
    component() {
      if (!this.currentUser) {
        return null;
      }

      switch (this.currentUser.role.name) {
        case 'processor' :
          return ProcessorBrowse;
        case 'contractor':
          return ContractorBrowse;
      }
    },
  },
};
</script>
